import { AxiosInstance } from "axios"
import { GenericResponse } from "."

export interface PromoCodeModel {}

export interface PromoCodeListRequest {
    from: string
    to: string
}

export interface PromoByIdNumber {
    promocode_id: string
}

const promoCodeApi = (apiInstance: AxiosInstance) => {
    const promoCodesList = async (): Promise<GenericResponse> => {
        const res: Promise<GenericResponse> = apiInstance.get(`/promo/index`)
        return res
    }

    const addPromoCodes = async (data: any): Promise<any> => {
        // delete parcelData.id;
        const addParcelDetail = apiInstance.post("/promo/create-promocode", data)
        return addParcelDetail
    }

    const editPromoCodes = async (data: any): Promise<any> => {
        const id = data.id
        data.promocode_id = id
        delete data.id
        const addParcelDetail = apiInstance.post("/promo/update-promocode", data)
        return addParcelDetail
    }

    const PromoById = async (data: any): Promise<any> => {
        const res = apiInstance.post("/promo/get-by-id", { promocode_id: data.id })
        return res
    }

    const deletePromoCodes = async (data: any): Promise<any> => {
        const addParcelDetail = apiInstance.post("/promo/delete-promocode", data)
        return addParcelDetail
    }
    return {
        promoCodesList,
        addPromoCodes,
        PromoById,
        editPromoCodes,
        deletePromoCodes
    }
}

export default promoCodeApi
